import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Earth = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Earth